module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_Brazil.ba3804c4.jpg";